// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.m-input-icon[data-v-f7d63642] {\n  height: 42px;\n}\n", ""]);
// Exports
module.exports = exports;
